import { Injectable } from '@angular/core';
import { Auth, signOut } from '@angular/fire/auth';
import { BFF_URL } from '../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private accessToken: string | null = null;
  constructor(private auth: Auth, private http: HttpClient) {}

  login(email: string, password: string): Promise<any> {
    const headers = new HttpHeaders({
      'content-type': 'application/json'
      });
      return new Promise<any>((resolve, reject) => {
        this.http.post<any>(`${BFF_URL}/v1/auth/login`, 
        { email, password }, 
        { 
          headers: new HttpHeaders({ 'content-type': 'application/json' }),
          withCredentials: true 
        }
      )
            .pipe(take(1))
            .subscribe({
                next: (result) => {
                  this.accessToken = result.token; // save the token
                  resolve(result);},
                error: (error) => reject(error)
            });
        });
  }

  signup(email: string, password: string, firstName, lastName): Promise<any> {
    const headers = new HttpHeaders({
    'content-type': 'application/json'
    });

    return new Promise<any>((resolve, reject) => {
    this.http.post<any>(`${BFF_URL}/v1/auth/signup`, {email, password, firstName, lastName},  { 
      headers: new HttpHeaders({ 'content-type': 'application/json' }),
      withCredentials: true 
    }).pipe(take(1))
        .subscribe({
            next: (result) => {
              this.accessToken = result.token; // save the token
              resolve(result);},
            error: (error) => reject(error)
        });
    });
  }

  logout(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.http.put<any>(`${BFF_URL}/v1/auth/logout`, {}, { 
        withCredentials: true // Required to clear the HttpOnly cookie
      })
      .pipe(take(1))
      .subscribe({
        next: (result) => {
          //Clear local memory only AFTER the API call succeeds
          this.clear(); 
          signOut(this.auth);
          resolve(result);
        },
        error: (error) => {
          this.clear(); 
          reject(error);
        }
      });
    });
  }
  
  refresh(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<any>(`${BFF_URL}/v1/auth/refresh-token`, {}, {
        withCredentials: true
      })
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.accessToken = res.accessToken;
          resolve(res);
        },
        error: reject
      });
    });
  }

  getToken(): string | null {
    return this.accessToken;
  }
  clear() {
    this.accessToken = null;
  }
  getShopifyToken() : Promise<any> {
    const headers = new HttpHeaders({
      'content-type': 'application/json'
      });
      return new Promise<any>((resolve, reject) => {
        this.http.post<any>(`${BFF_URL}/v1/shopify/login`, {}, { headers })
            .pipe(take(1))
            .subscribe({
                next: (result) => resolve(result),
                error: (error) => resolve(null) // return null instead of the api error to proceed with the flows
            });
    });
  }
}